export default __webpack_public_path__ + "static/media/cbm_logo.c6bf97d1.png";